var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Pivot, R, RP, SharedGradients } from "apparatus/library/common";
import { Group, Path } from "paper";
import { staticImplements } from "types";
let HydrothermalAutoclave = class HydrothermalAutoclave {
    render({ size }) {
        // Shell sizing
        const shell_diameter = size / 1.75; // Canonical 100
        const shell_height = size; // Canonical 175
        const lid_diameter = shell_diameter + 20;
        const lid_height = shell_height / 3;
        const lid_overlap = lid_height * 0.5;
        const lid_top_diameter = shell_diameter / 4;
        const rod_length = shell_diameter * 1.7 + 30;
        const rod_diameter = 10;
        const shell = (new Path.Rectangle(R(0, 0, shell_diameter, shell_height, Pivot.BOTTOM_CENTER)));
        const shellOutline = shell.clone();
        shell.withGradientFill("right", SharedGradients.cylinderMetal);
        shellOutline.withStroke("default");
        const shellRidges = new Group([]);
        for (var i = 0; i < 3; i++) {
            var y = (i + 1) * -(shell_height - lid_overlap + 4) / 4;
            shellRidges.addChild(new Path.Line(P(-shell_diameter / 2, y), P(shell_diameter / 2, y))
                .withStroke(4)
                .withGradientStroke("right", SharedGradients.cylinderDarkMetal));
        }
        const lid = (new Path.Rectangle(R(0, 0, lid_diameter, lid_height, Pivot.BOTTOM_CENTER), 2.0));
        const lidStroke = lid.clone();
        lid.withGradientFill("right", SharedGradients.cylinderMetal);
        lidStroke.withStroke("default");
        var lidGroup = new Group([lid]);
        // Add lid indentations.
        lidGroup.addChildren([
            (new Path.Rectangle(RP(-shell_diameter / 2, -lid_height, -8, -0.7 * lid_height), 2.0)
                .withGradientFill("right", [["#aaaaaa", 0], ["#eeeeee", 1]])),
            (new Path.Rectangle(RP(8, -lid_height, shell_diameter / 2, -0.7 * lid_height), 2.0)
                .withGradientFill("right", [["#888888", 0], ["#cccccc", 1]])),
        ]);
        lidGroup.addChild(lidStroke);
        var y = -shell_height + lid_overlap;
        lidGroup.withPositionDelta({ y });
        const top1 = (new Path.Rectangle(R(0, 0, lid_top_diameter, 20, Pivot.BOTTOM_CENTER))
            .withGradientFill("right", SharedGradients.cylinderMetal)
            .withStroke("default"));
        y -= lid_height;
        top1.withPositionDelta({ y });
        const rod = (new Path.Rectangle(R(0, 0, rod_length, rod_diameter, Pivot.BOTTOM_CENTER), 1.0)
            .withGradientFill("down", SharedGradients.cylinderMetal)
            .withStroke("default"));
        rod.withPositionDelta({ y: y - 7 });
        const top2 = (new Path.Rectangle(R(0, 0, lid_top_diameter + 8, 8, Pivot.BOTTOM_CENTER), 3.0)
            .withGradientFill("down", SharedGradients.cylinderMetal)
            .withStroke("default"));
        y -= 20;
        top2.withPositionDelta({ y });
        const graphic = new Group([
            shell,
            shellRidges,
            shellOutline,
            lidGroup,
            rod,
            top1,
            top2,
        ]);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            snapping: [
                shell.placeable(),
            ]
        };
    }
};
HydrothermalAutoclave.properties = {
    label: "Hydrothermal Autoclave",
    defaultAppearance: {
        size: 175
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 100, max: 250,
        }
    ],
};
HydrothermalAutoclave = __decorate([
    staticImplements()
], HydrothermalAutoclave);
export { HydrothermalAutoclave };
